import { render, staticRenderFns } from "./CompTable.vue?vue&type=template&id=68179f4c"
import script from "./CompTable.vue?vue&type=script&lang=js"
export * from "./CompTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports